import { EFilterType } from 'shared/enums/EFilterType';

export const RANGE_FILTERS = [EFilterType.price, EFilterType.totalArea, EFilterType.workplaceCount];
